var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-page-layout',{attrs:{"is-loading":_vm.isLoading,"toolbar-title":"pages.launcher.images.title","progress-bar-loading":_vm.isLoading === 'images',"toolbar-buttons":_vm.toolbarButtons}})}
var staticRenderFns = []

export { render, staticRenderFns }